export default "__VITE_ASSET__Cae43SJR__"